import {z} from 'zod'

const boolEnvVar = z
    .literal('true')
    .or(z.literal('false'))
    .or(z.literal(''))
    .optional()
    .transform(value => value == 'true')

export const envVars = z
    .object({
        VITE_APP_TITLE: z.string(),
        VITE_API_ENDPOINT: z.string().url(),
        VITE_APP_DOMAIN: z.string(),
        VITE_GTM_ID: z.string().optional(),
        VITE_SENTRY_DSN: z.string().optional(),
        VITE_APP_GOOGLE_CLIENT_ID: z.string(),
        VITE_APP_GOOGLE_OAUTH_URL: z.string(),
        VITE_APP_GOOGLE_CALLBACK_URL: z.string(),
        VITE_GOOGLE_API_KEY: z.string(),
        VITE_AIRBNB_APP_ID: z.string(),
        VITE_AIRBNB_DATA_SCOPE: z.string(),
        VITE_AIRBNB_DATA_REDIRECT_URI: z.string().url(),
        VITE_API_ENDPOINT_NODE: z.string().url(),
        VITE_IS_FLOOR_PLAN_ENABLED: boolEnvVar,
        VITE_IS_AI_CHATBOT_ENABLED: boolEnvVar,
        VITE_AI_CHATBOT_API_URL: z.string().url().or(z.literal('')).optional()
    })
    .parse(import.meta.env)
